<script>
export default {
    name: "CancelProcedureForm",

    props: {

        showModal: Boolean,
        procedure: Object,
    },

    methods: {

        cancelProcedure() {
            this.$root.loading = true;
            this.$http.post(`MedicalFile/DeleteProcedureRequest?ProcedureID=${this.procedure.procedureID}&Ref=${this.procedure.ref}&PatientId=${this.procedure.patientID}&VisitNo=${this.procedure.visitNo}&ItemName=${this.procedure.procedure}&UserName=${this.$root.username}`).then(response => {
                this.$emit(`refresh`);
                this.$root.loading = false;
                this.$emit(`closeModal`);
                window.Swal.fire({ type: `success`, text: response.data });
            }).catch(() => { this.$root.loading = false; this.$emit(`closeModal`); });
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-1/3 sm:w-10/12">
  <template v-slot:title>
    <h5 class="text-base font-medium">Cancel Procedure</h5>
  </template>
  <template v-slot:modal-body>
    <div class="flex flex-wrap -m-3">
        <div class="w-full flex md:flex-row sm:flex-col p-tiny my-1">
            <div class="flex-1">
                <h5 class="font-semibold">Procedure: {{ procedure.procedure }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-semibold">Requested By: {{ procedure.requestedBy }}</h5>
            </div>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button 
        class="btn-danger btn-sm text-xs rounded mr-6" 
        @click="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Close</button>
    <button 
        class="btn-warning btn-sm text-xs rounded" 
        @click.prevent="cancelProcedure">
            <i class="fa fa-undo"></i> Cancel Procedure</button>
  </template>
</tail-modal>
</template>